<template>
  <div>
    <div class="main-title">企业设备地址管理</div>
    <el-row class="content-container">
      <Search @search="minSearchSubmit" @reset="resetQueryParams">
        <el-form label-width="80px">
          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="所属区域">
                <el-input
                  type="text"
                  placeholder="请输入所属区域"
                  v-model="queryParams.areaName"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="企业名称">
                <el-input
                  type="text"
                  placeholder="请输入企业名称"
                  v-model="queryParams.entName"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label=" 企业类型">
                <el-select
                  v-model="queryParams.entType"
                  placeholder="请选择企业类型"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="生产企业" value="1"></el-option>
                  <el-option label="流通企业" value="0"></el-option>
                  <el-option label="零售企业" value="2"></el-option>
                  <!-- <el-option label="医疗企业" value="3"></el-option> -->
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </Search>
      <div class="table-container">
        <el-table :data="entList" style="width: 100%">
          <el-table-column type="index" label="序号" />
          <el-table-column prop="organ_name" label="企业名称" />
          <el-table-column prop="area_name" label="所属区域" />
          <el-table-column prop="ent_address" label="企业地址" />
          <el-table-column prop="tax_no" label="组织机构代码" />
          <el-table-column prop="email" label="企业邮箱" />
          <el-table-column prop="phone" label="联系方式" />
          <el-table-column label="操作" width="230px">
            <template slot-scope="scope">
              <el-button type="text" @click="loadVideoList(scope.row)"
                >设置视频地址</el-button
              >
              <el-button type="text" @click="humitureDevices(scope.row)"
                >设置温湿度设备</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :current-page.sync="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-row>
    <el-dialog title="视频列表" :visible.sync="dialogVisible" width="1200px">
      <el-table
        :data="videoList"
        style="width: 100%;margin-bottom: 30px"
        :fit="true"
      >
        <el-table-column type="index" label="序号" width="80" />
        <el-table-column label="登录Ip" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.videoIp" />
          </template>
        </el-table-column>
        <el-table-column label="登录端口" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.videoPort" />
          </template>
        </el-table-column>
        <el-table-column label="登录用户名" width="250">
          <template slot-scope="scope">
            <el-input v-model="scope.row.user" />
          </template>
        </el-table-column>
        <el-table-column label="登录密码" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.passWord" />
          </template>
        </el-table-column>
        <el-table-column label="视频名称" width="200">
          <template slot-scope="scope">
            <el-input v-model="scope.row.videoDesc" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="confirm(scope.row)"
              >确认</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <WebVideo
        :channelList="channelList"
        :edit="true"
        v-if="showWebVideo"
        :loginIp="videoList[0] ? videoList[0].videoIp : ''"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitVideo">保 存</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="设置温湿度设备"
      :close-on-click-modal="false"
      :visible.sync="humitureVisible"
      @close="resetFormClose()"
      width="1200px"
    >
      <EnterpriseAdminDialog
        @childSuccess="success"
        :listid="listid"
        style="min-height:460px"
      />
    </el-dialog>
  </div>
</template>

<script>
import WebVideo from 'components/web-video/web-video';
import Search from 'components/search/search';
import searchMixin from 'mixin/search';
import PaginationMixin from 'mixin/pagination';
import webVideoMixin from 'mixin/web-video';
import EnterpriseAdminDialog from './enterprise-admin-dialog';
export default {
  data() {
    return {
      isAdd: true,
      savedChannelList: [],
      channelList: [],
      showWebVideo: false,
      dialogVisible: false,
      humitureVisible: false,
      enterpriseId: '',
      entList: [],
      queryParams: {
        areaName: '',
        entName: '',
        entType: ''
      },
      videoList: [],
      showTable: false,
      listid: ''
    };
  },
  mixins: [searchMixin, PaginationMixin, webVideoMixin],
  mounted() {
    this.querySubmit();
    // this.loadVideoList()
  },
  methods: {
    querySubmit() {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: this.pageSize
            },
            params: {
              ...this.queryParams,
              handlerName: 'ent_info_list'
            }
          })
        }
      }).then(res => {
        this.entList = res.list ? [...res.list] : [];
        this.total = res.total || 0;
      });
    },
    // 设置温湿度设备
    humitureDevices(row) {
      this.humitureVisible = true;
      this.listid = row.organ_id;
    },
    resetFormClose() {
      this.humitureVisible = false;
    },
    success() {
      this.humitureVisible = false;
      this.querySubmit();
    },
    loadVideoList(row) {
      this.enterpriseId = row.organ_id;
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 100000
            },
            params: {
              enterpriseId:
                this.enterpriseId || '1DFQ8TQK05BD2I0AB05021GCJ0001JK4',
              handlerName: 'ent_video_list'
            }
          })
        }
      }).then(res => {
        if (res.list.length === 0) {
          this.isAdd = true;
          this.videoList = [
            {
              videoIp: '',
              videoPort: '',
              user: '',
              passWord: '',
              videoDesc: '',
              id: ''
            }
          ];
          this.dialogVisible = true;
        } else {
          this.isAdd = false;
          this.videoList = res.list.map(item => {
            return {
              videoIp: item.video_ip,
              videoPort: item.video_port,
              user: item.user,
              passWord: item.pass_word,
              videoDesc: item.video_desc,
              id: item.id
            };
          });
          this.loadChannelList(res.list[0].id);
        }
        this.dialogVisible = true;
        setTimeout(() => {
          this.showTable = true;
        }, 1000);
      });
    },
    loadChannelList(videoId) {
      this.$request({
        url: 'rest/statistic/reportData',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 100000
            },
            params: {
              videoId,
              handlerName: 'ent_video_pass_list'
            }
          })
        }
      }).then(res => {
        this.savedChannelList = [...res.list];
      });
    },
    submitVideo() {
      const videoList = this.videoList.map(item => {
        return {
          enterpriseId: this.enterpriseId,
          videoIp: item.videoIp,
          videoPort: item.videoPort,
          user: item.user,
          passWord: item.passWord,
          videoDesc: item.videoDesc,
          id: item.id
        };
      });
      this.$request({
        url: 'rest/entVideoInfo/mergeEntVideoInfo',
        data: {
          json: JSON.stringify({
            params: {
              videoList
            }
          })
        }
      }).then(res => {
        this.submitChannel(res);
      });
    },
    submitChannel(videoId) {
      const videoPassList = this.channelList.map(item => {
        return {
          dataStatus: item.avaiable ? '1' : '0',
          videoChannel: item.id,
          videoChannelDesc: item.currentName,
          videoId,
          id: item.savedId
        };
      });
      this.$request({
        url: 'rest/entVideoPassInfo/mergeEntVideoPassInfo',
        data: {
          json: JSON.stringify({
            params: {
              videoPassList
            }
          })
        }
      }).then(res => {
        this.$alert('保存成功');
        this.dialogVisible = false;
      });
    },
    confirm(row) {
      const checkResult = this.checkRequired();
      if (!checkResult.checked) {
        this.$alert(checkResult.msg);
        return;
      }
      this.showWebVideo = true;
      this.channelList = [];
      setTimeout(() => {
        this.videoLogin(
          {
            loginIp: this.videoList[0].videoIp,
            loginPort: this.videoList[0].videoPort,
            userName: this.videoList[0].user,
            password: this.videoList[0].passWord,
            id: row.organ_id
          },
          () => {
            if (this.isAdd) {
              this.channelList = this.channelListMap[row.organ_id].map(item => {
                return {
                  ...item,
                  currentName: item.name,
                  savedId: '',
                  avaiable: false
                };
              });
            } else {
              this.channelList = this.channelListMap[row.organ_id].map(item => {
                let savedChannel = null;
                for (const i in this.savedChannelList) {
                  if (this.savedChannelList[i].video_channel === item.id) {
                    savedChannel = this.savedChannelList[i];
                  }
                }
                return {
                  ...item,
                  savedId: savedChannel ? savedChannel.id : '',
                  currentName: savedChannel
                    ? savedChannel.video_channel_desc
                    : '',
                  avaiable: savedChannel
                    ? savedChannel.data_status === '1'
                    : false
                };
              });
            }
          }
        );
      }, 100);
    },
    checkRequired() {
      const result = {
        msg: '',
        checked: true
      };
      if (!this.videoList[0].videoIp.trim()) {
        result.msg = '登录ip必填';
        result.checked = false;
      }
      if (!this.videoList[0].videoPort.trim()) {
        result.msg = '登录端口必填';
        result.checked = false;
      }
      if (!this.videoList[0].user.trim()) {
        result.msg = '登录用户名必填';
        result.checked = false;
      }
      if (!this.videoList[0].user.trim()) {
        result.msg = '登录密码必填';
        result.passWord = false;
      }
      return result;
    }
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      if (!newVal) {
        this.showWebVideo = false;
      }
    }
  },
  components: {
    Search,
    WebVideo,
    EnterpriseAdminDialog
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.dialogHeight
  min-height 555px
.pagination
  padding 20px
  background #fff
  text-align right
</style>
